import { http } from '../../config/axios'

const findPerfil = (params: any): Promise<any> => {
  const queryParams = params
    ? Object.keys(params)
        .map((k) => encodeURIComponent(params[k]))
        .join('/')
    : ''
  return http
    .get('api/perfil/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findPerfil', error)
      throw Error(error.response.data)
    })
}

export default findPerfil;
